/**
 * Variations API Client
 *
 * Generates image variations via POST /api/v2/generate/variations
 * Pricing loaded from DB via GET /api/v2/generate/variations/pricing
 */

import { apiClient, getCsrfToken } from '../api-client';

export interface VariationPricing {
  per_image: number;
  per_image_4k: number;
}

export async function getVariationsPricing(): Promise<VariationPricing> {
  const response = await apiClient.get<{ success: boolean; pricing: VariationPricing }>(
    '/api/v2/generate/variations/pricing',
  );
  return response.data.pricing;
}

export interface VariationParams {
  image: File;
  user_context: string;
  brand_id?: string;
  ratio: string;
  resolution: string;
  image_count: number;
  image_format: string;
  png_quality: string;
}

export interface VariationImage {
  image_id: string;
  image_url: string;
}

export interface VariationResult {
  success: boolean;
  images: VariationImage[];
  total_credits_used: number;
  error?: string;
}

export async function generateVariations(params: VariationParams): Promise<VariationResult> {
  const formData = new FormData();

  const csrfToken = await getCsrfToken();
  if (csrfToken) {
    formData.append('csrf_token', csrfToken);
  }

  formData.append('image', params.image);
  formData.append('user_context', params.user_context);
  formData.append('ratio', params.ratio);
  formData.append('resolution', params.resolution);
  formData.append('image_count', String(params.image_count));
  formData.append('image_format', params.image_format);
  formData.append('png_quality', params.png_quality);

  if (params.brand_id) {
    formData.append('brand_id', params.brand_id);
  }

  const response = await apiClient.post<VariationResult>(
    '/api/v2/generate/variations',
    formData,
  );

  return response.data;
}
